const isDetachedTerminalInstance = (t) => typeof t.instanceId !== 'number';
class TerminalLinkQuickPickEvent extends MouseEvent {
}
const terminalEditorId = 'terminalEditor';
export { TerminalLinkQuickPickEvent, isDetachedTerminalInstance, terminalEditorId };
